<template>
  <Head :title="'Insights - ' + page.name" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <report-view 
            :page="page" 
            :client="client" 
            :connections="connections" 
            :section_id="section_id" 
            :all_pages="all_pages"
          ></report-view>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  page: Object,
  client: Object,
  connections: Array,
  section_id: [Number, String],
  all_pages: Array
});
</script>

